export default __webpack_public_path__ + "ed717d78550d6fc150c78aa07ed95a1d.png";